import { CreateListSupplierVehicle, UploadSupplierVehicleFormFile } from "../../../reduxToolkit/Files/FilesApi"; // Import API functions for uploading files and creating supplier vehicle records
import { toast } from "react-toastify"; // Import toast notification library
import routes from "../../../Routes/routes";
import {errorMsg} from "../../../Apis/functions"; // Import route definitions for navigation

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

/**
 * Component logic to handle uploading supplier vehicle files and creating supplier vehicle records.
 *
 * @param {function} t - Translation function (i18next).
 * @param {function} dispatch - Redux dispatch function.
 * @param {function} navigate - Function to navigate to different routes.
 * @param {object} spreadsheetData - Parsed spreadsheet data, used to verify file presence.
 * @param {object} data - Data object containing supplier vehicle information.
 * @param {function} setUpdate - Function to trigger UI state updates.
 * @param {function} getFormData - Function to retrieve form data including file uploads.
 * @param {function} isValidFile - Callback triggered after successful file upload validation.
 */
export const CreationErrorsSupplierVehicleApp = ({
                                                     t,
                                                     dispatch,
                                                     navigate,
                                                     spreadsheetData,
                                                     data,
                                                     setUpdate,
                                                     getFormData,
                                                     isValidFile
                                                 }) => {

    // Handle file upload for supplier vehicles
    const handleUploadFile = () => {
        setUpdate(true); // Trigger UI update

        if (spreadsheetData) {
            const formData = getFormData(); // Retrieve form data including the file

            if (formData) {
                dispatch(UploadSupplierVehicleFormFile(formData)) // Dispatch file upload action
                    .then(({ payload: { data: { data, success } } }) => {
                        if (success === true) {
                            isValidFile(data); // Execute callback on successful upload
                        }
                    })
                    .catch(() => {
                        toast.error(t('fail_to_upload_file').toUpperCase()); // Show error if upload fails
                    });
            }
        } else {
            toast?.warn(t('there_is_not_file_to_upload').toUpperCase()); // Warn if no file selected for upload
        }
    };

    // Handle confirmation and creation of supplier vehicle records
    const handleConfirm = () => {
        dispatch(CreateListSupplierVehicle(data)).then(({ payload: { data: { success, code } } }) => {
            if (success === true) {
                toast.success(t('has_been_created_successfully')); // Show success notification
                navigate(routes.vehicleSupplier.list); // Navigate to supplier vehicle list page
            } else errorMsg(code)
        });
    };

    // Return the handler functions to be used in the UI
    return {
        handleConfirm,
        handleUploadFile
    };
};

// Export the component logic for use in other parts of the application
export default CreationErrorsSupplierVehicleApp;
